import { Component, OnInit, Input } from '@angular/core';
import { User, TinAccess } from '../manage-access.model';
import { TIN_STATUS } from '../manage-access.constant';
import groupBy from 'lodash/groupBy';

@Component({
  selector: 'cigna-user-tins-grouped-item',
  templateUrl: './user-tins-grouped-item.component.html',
  styleUrls: ['./user-tins-grouped-item.component.scss'],
})
export class UserTinsGroupedItemComponent implements OnInit {
  @Input() user: User;
  @Input() show = 2; // 0 index based, 2=3
  @Input() moreLabel = 'more';

  @Input() unassignedTins: string[] = [];
  @Input() assignedTins: string[] = [];

  @Input() totalItems = 0;
  get expanded(): boolean {
    return this._isExpanded;
  }
  set expanded(expanded: boolean) {
    this._isExpanded = expanded;
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  private _isExpanded = false;

  showMore(): void {
    this.expanded = true;
  }

  ngOnInit() {
    if (this.user === undefined) {
      return;
    }

    const tinsGrouped = groupBy(this.user.tins, (tin) => tin.status);

    const assignedTinsGroup = tinsGrouped[TIN_STATUS.assigned] || [];
    this.assignedTins = assignedTinsGroup.map(this.getTinName);

    const unassignedTinsGroup = tinsGrouped[TIN_STATUS.unassigned] || [];
    this.unassignedTins = unassignedTinsGroup.map(this.getTinName);

    this.totalItems = this.assignedTins.length + this.unassignedTins.length;
  }

  getTinName(tin: TinAccess): string {
    return tin.name !== '' && tin.name !== ' '
      ? `${tin.tin} (${tin.name})`
      : `${tin.tin}`;
  }
}
